export default __webpack_public_path__ + "static/media/sean.96255a99.JPG";